import CustomModal from "./index.jsx";

export default CustomModal;
